import styled from "styled-components";

const Rightside = (props) => {
    return <div>this is the right side</div>
};

export default Rightside;